// extracted by mini-css-extract-plugin
export default {"searchSlide":"SearchSlide_searchSlide__S1Jjx","hidden":"SearchSlide_hidden__12+XP"};